import React from 'react';
import Footer from '../../components/footer';
import SellerTabs from '../../components/seller/sellerTab';

import "../../css/seller/login.css"

export default function SellerLogin() {





 
 return (
  <div>
   <nav className="navbar navbar-expand-lg" style={{ backgroundColor: "rgba(0, 102, 255, 0.45)" }}>
    <div className="container">
     <a className="navbar-brand d-flex pt-3" href="/sellerLogin">
      <img src={"/img/logo.png"} className="img-log" alt="img-logo" width={60} height={60}></img>
      <div className="logo-title  ps-2 d-flex" style={{ color: "white" }}> Seller Center</div></a>
     <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
      <span className="navbar-toggler-icon"></span>
     </button>

     <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
      <div className="offcanvas-header">
       <a className="navbar-brand d-flex" href="/">
        <img src={"/img/logo.png"} className="img-log" alt="img-logo" width={60} height={60}></img>
        <div className="logo-sidebar  ps-2">W-Shop</div></a>
       <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div className="offcanvas-body">
       <ul className="navbar-nav ms-auto me-5">
        <a href="/" className=" text-decoration-none  beranda">
         Beranda W-Shop
        </a>
       </ul>
      </div>

     </div>
    </div>
   </nav>

   <div className='main'>
    <div className='container py-6'>
     <div className='row py-5'>
      <div className='col-12 col-lg-6 mb-5'>
       <h1 className='jadi mt-5'>Jadilah Penjual Terbaik</h1>
       <p className='kelola'>Kelola toko anda secara efisien di W-Shop dengan W-Shop Seller Centre</p>
       <img alt='' src='/img/tokoSeller.png' className=' d-block ms-auto me-auto'/>
      </div>
      <div className='col-12 col-lg-6'>
       <div className='tabs py-5 ms-auto me-auto px-3'>
       <SellerTabs/>
       </div>
      </div>
     </div>
    </div>
   </div>
   <Footer />
  </div>
 );
}
